const Home = () => import('@/views/Home/index.vue');
const Market = () => import('@/views/Market/index.vue');
const NFT = () => import('@/views/NFT/index.vue');
const Exchange = () => import('@/views/Exchange/index.vue');
const Account = () => import('@/views/Account/index.vue');
const MarketDetails = () => import('@/views/Market/details.vue');
const NftDetails = () => import('@/views/NFT/details.vue');
const Propaganda = () => import('@/views/Propaganda/index.vue');
const Invite = () => import('@/views/Account/invite.vue');
const Set = () => import('@/views/Set/index.vue');
const router = [
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: {
      position: 'relative',
      requireAuth: false,
      lever: 1,
    },
  },
  {
    path: '/propaganda',
    name: 'Propaganda',
    component: Propaganda,
    meta: {
      position: 'relative',
      requireAuth: false,
    },
  },
  {
    path: '/market',
    name: 'Market',
    component: Market,
    meta: {
      position: 'relative',
      requireAuth: false,
      lever: 1,
    },
  },
  {
    path: '/marketDetails',
    name: 'MarketDetails',
    component: MarketDetails,
    meta: {
      position: 'relative',
      requireAuth: true,
      lever: 1.1,
    },
  },
  {
    path: '/nft',
    name: 'NFT',
    component: NFT,
    meta: {
      position: 'relative',
      requireAuth: true,
      lever: 1,
    },
  },
  {
    path: '/invite',
    name: 'Invite',
    component: Invite,
    meta: {
      position: 'relative',
      requireAuth: true,
      lever: 1.1,
    },
  },
  {
    path: '/exchange',
    name: 'Exchange',
    component: Exchange,
    meta: {
      position: 'relative',
      requireAuth: true,
      lever: 1,
    },
  },
  {
    path: '/account',
    name: 'Account',
    component: Account,
    meta: {
      position: 'relative',
      requireAuth: true,
      lever: 1,
    },
  },
  {
    path: '/nftDetails',
    name: 'NftDetails',
    component: NftDetails,
    meta: {
      position: 'relative',
      requireAuth: true,
      lever: 1.1,
    },
  },
  {
    path: '/set',
    name: 'Set',
    component: Set,
    meta: {
      position: 'relative',
      requireAuth: true,
      lever: 1.1,
    },
  },
];

export default router;
